/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { Credentials } from '@opengeoweb/api';
import { getHeaders, handleResponse } from '@opengeoweb/api';
import { getPresetBaseUrl } from '../utils';

export type FavouritePresetType = 'workspace' | 'view';

// Namespaced keys distinguish workspace and view IDs.
export interface UserPreferences {
  [key: string]: unknown;
  favouritePresets?: string[];
}

export const getUserPreferences = async (
  auth?: Credentials,
): Promise<UserPreferences> =>
  fetch(`${getPresetBaseUrl()}/user/preferences`, {
    headers: getHeaders(auth),
  }).then(handleResponse) as Promise<UserPreferences>;

export const setFavouritePreset = async (
  presetType: FavouritePresetType,
  presetId: string,
  isFavourite: boolean,
  auth?: Credentials,
): Promise<UserPreferences> =>
  fetch(
    `${getPresetBaseUrl()}/user/preferences/favourite-presets/${presetType}/${encodeURIComponent(presetId)}`,
    {
      method: isFavourite ? 'PUT' : 'DELETE',
      headers: getHeaders(auth),
    },
  ).then(handleResponse) as Promise<UserPreferences>;
